import { BaseAPI, Configuration } from "../../api/runtime";

export function createOpenApiInstance<T extends BaseAPI>(type: { new (...args: any[]): T }, configuration?: Configuration): T {
    let newInstance: T = new type(configuration);
    newInstance = setThisBindings(newInstance); // must bind this if we want to use generic open api calls
    return newInstance;
}

function setThisBindings(obj: any): any {
    const functionNames = getAllFuncs(obj);
    for (let fName of functionNames) {
        obj[fName] = obj[fName].bind(obj);
    }
    return obj;
}

function getAllFuncs(toCheck: any): string[] {
    var props: any = [];
    var obj = toCheck;
    do {
        props = props.concat(Object.getOwnPropertyNames(obj));
    } while ((obj = Object.getPrototypeOf(obj)));

    return props.sort().filter((e: any, i: any, arr: any) => {
        if (e !== arr[i + 1] && typeof toCheck[e] === "function") {
            return true;
        }
        return false;
    });
}